import { useState } from 'react';
import PosGlobalConfigForm from './PosGlobalConfigForm';
import PosAdminSettingsForm from './PosAdminSettingsForm';
import { POS_ADMIN_CONFIG_TABS } from '../constants/posConst';
import '../css/PosAdmin.css';

/**
 * /admin -> Config, in two tabs: General (settings every till reads) and
 * Admin Settings (how clients pay the Website Pal for their subscription).
 *
 * @param {object} props
 * @param {string} props.signedInEmail
 * @returns {JSX.Element}
 */
function PosAdminConfigScreen({ signedInEmail }) {
  const [tab, setTab] = useState(POS_ADMIN_CONFIG_TABS[0].key);

  return (
    <div className="pa-screen">
      <div className="pa-tabs" role="tablist" aria-label="Config sections">
        {POS_ADMIN_CONFIG_TABS.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={tab === key}
            className={`pa-tab${tab === key ? ' active' : ''}`}
            onClick={() => setTab(key)}
          >
            {label}
          </button>
        ))}
      </div>

      {tab === 'adminSettings' ? (
        <>
          <header className="pa-screen-head">
            <div>
              <h1 className="pa-screen-title">Admin Settings</h1>
              <p className="pa-screen-sub">How clients pay for their subscription. Shown on every client&rsquo;s checkout screen.</p>
            </div>
          </header>
          <PosAdminSettingsForm signedInEmail={signedInEmail} />
        </>
      ) : (
        <PosGlobalConfigForm signedInEmail={signedInEmail} />
      )}
    </div>
  );
}

export default PosAdminConfigScreen;
